import { pick } from 'lodash';
import {
  AlertStatusValue,
  INITIAL_FILTER_VALUES,
  TarrifSummaryAtomValues,
} from '../tariff-summary';
import { Sorting, SortingParam } from 'src/common/components/Filters/constants/sorting';
import { createSortingParamsSetter, createSortingParamsValidator } from './sorting';

const ALLOWED_SORTING = new Set([
  'bundleProductCode',
  'activeCount',
  'usedData',
  'sent',
  'usedSeconds',
  'forecastData',
  'forecastSMS',
  'forecastSeconds',
  'allowanceData',
  'allowanceSMS',
  'allowanceSeconds',
]);
const ALLOWED_SORTING_DIRECTION = new Set<Sorting>(['asc', 'desc']);
export const checkIfTariffSummarySortingParamsValid = createSortingParamsValidator({
  allowedColumnNames: ALLOWED_SORTING,
  allowedDirection: ALLOWED_SORTING_DIRECTION,
});

export const setTariffSummarySortingParams = createSortingParamsSetter({
  allowedColumnNames: ALLOWED_SORTING,
  allowedDirection: ALLOWED_SORTING_DIRECTION,
});

const mapTariffSummaryFiltersToURLSearchParams = (filters: TarrifSummaryAtomValues) => {
  const { account, alertStatus } = filters;

  const searchParams = new URLSearchParams();

  if (account) {
    searchParams.set('account', account);
  }

  if (alertStatus) {
    searchParams.set('alertStatus', alertStatus);
  }

  return searchParams;
};

export const combinedTariffSummaryFiltersAndSortingMapper = (
  filters: TarrifSummaryAtomValues,
  sorting: SortingParam,
) => {
  const params = mapTariffSummaryFiltersToURLSearchParams(filters);
  setTariffSummarySortingParams({ sorting, searchParams: params });
  return params;
};

export const mapURLSearchParamsToTariffSummaryFilters = (urlSearchParams: URLSearchParams) => {
  const filters = Object.fromEntries(urlSearchParams);

  const { account, alertStatus } = pick(filters, Object.keys(INITIAL_FILTER_VALUES));

  return {
    account: account || null,
    alertStatus: (alertStatus as AlertStatusValue) ?? INITIAL_FILTER_VALUES.alertStatus,
  };
};

export const mapURLSearchParamsToTariffSummarySorting = (
  params: URLSearchParams,
): SortingParam | null => {
  const columnName = params.get('columnName');

  if (!columnName) {
    return null;
  }

  const sort = params.get('sort') as 'asc' | 'desc' | null;
  const sortingParamsValid = checkIfTariffSummarySortingParamsValid({
    sorting: { columnName, sort },
  });
  if (sortingParamsValid) {
    return { columnName, sort };
  }

  return null;
};
